import * as React from "react";
import {
  DataGrid,
  GridFooterContainer,
  useGridApiContext,
  useGridSelector,
  gridRowCountSelector,
  gridPageSelector,
  gridPageCountSelector,
} from "@mui/x-data-grid";
import { Pagination } from "@mui/material";
import PropTypes from "prop-types";

const PAGE_SIZE = 10;

function CustomFooter() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);

  const from = rowCount === 0 ? 0 : page * PAGE_SIZE + 1;
  const to = Math.min((page + 1) * PAGE_SIZE, rowCount);
  const totalPages = Math.max(pageCount, 1);

  return (
    <GridFooterContainer>
      <div style={{ padding: "0 16px", fontSize: "13px" }}>
        {`${from}-${to} / ${rowCount}件`}
      </div>
      <Pagination
        count={totalPages}
        page={page + 1}
        onChange={(_, value) => apiRef.current.setPage(value - 1)}
        size="small"
      />
    </GridFooterContainer>
  );
}

export default function GroupDataTable({
  ownedGroups,
  setDisplayMode,
  setTargetGroup,
}) {
  const clicked2 = (element) => {
    if (element.id == undefined || element.id == "") {
      setDisplayMode(2); // 2: 非活性モード
    } else {
      setTargetGroup(element.row);
      setDisplayMode(1); // 1: 編集モード
    }
  };

  const columns = [
    {
      field: "Name",
      headerName: "グループ名",
      width: 150,
    },
    {
      field: "Note",
      headerName: "備考",
      width: 300,
    },
    { field: "id", headerName: "システムID", sortable: false, width: 320 },
  ];

  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        rows={ownedGroups}
        columns={columns}
        pageSize={PAGE_SIZE}
        rowsPerPageOptions={[PAGE_SIZE]}
        checkboxSelection={false}
        density="compact"
        autoHeight
        onRowClick={(ele2) => clicked2(ele2)}
        components={{ Footer: CustomFooter }}
        initialState={{ sorting: { sortModel: [{ field: "Name", sort: "asc" }] } }}
      />
    </div>
  );
}

GroupDataTable.propTypes = {
  ownedGroups: PropTypes.object,
  setDisplayMode: PropTypes.any,
  setTargetGroup: PropTypes.any,
};
